<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <div class="vx-card">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4 class="pb-4">Pending withdrawal requests</h4>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col mb-base">
                            <vs-input id="search-box" v-on:input="filterChanged" icon="search" size="large"
                                      v-model="searchInput"
                                      label-placeholder="Search"
                                      class="ml-6 mt-6"/>
                        </div>
                        <div class="vx-col mb-base grid-filter-icon-wrapper" v-on:click="showFilters = !showFilters">
                            <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                        </div>
                    </div>
                    <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFilters}">
                        <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilter" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibility()">{{column.name}}</vs-checkbox>
                            </span>
                        </div>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-material w-100 my-4 ag-grid-table"
                        :columnDefs="pendingListColumns"
                        :rowData="getWithdrawals"
                        :defaultColDef="defaultColDef"
                        :gridOptions="gridOptions"
                        rowSelection="multiple"
                        colResizeDefault="shift"
                        :animateRows="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true"
                        overlayNoRowsTemplate=" "
                        v-on:resolveRequest="requestResolved($event)"
                        v-on:gridReady="setGridSize($event)">
                    </ag-grid-vue>

                    <vs-pagination
                        :total="totalPages"
                        :max="paginationMaxSize"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import RestService from '../services/RestService';
    import StatisticsCardLine from '../components/statistics-cards/StatisticsCardLine';
    import VueApexCharts from 'vue-apexcharts';
    import CellRendererDate from './cell-renderer/CellRendererDate';
    import CellRendererButton from './cell-renderer/CellRendererButton';
    import CellRendererValue from './cell-renderer/CellRendererValue';
    import {AgGridVue} from 'ag-grid-vue';
    import '../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';

    export default {
        name: "withdrawal-admin",
        components: {
            StatisticsCardLine,
            VueApexCharts,
            AgGridVue,
            CellRendererDate,
            CellRendererButton,
            CellRendererValue
        },
        async beforeMount() {
            const pendingRequestsResponse = await RestService.requestPendingAdmin();
            if (pendingRequestsResponse.success) {
                this.pendingList = pendingRequestsResponse.data;
            }
        },
        methods: {
            setGridSize(params) {
                if (window.innerWidth > 1024)
                    params.api.sizeColumnsToFit();
                this.gridOptions.api.setDomLayout('autoHeight');
            },

            async requestResolved(param) {
                if (param) {
                    const pendingRequestsResponse = await RestService.requestPendingAdmin();
                    if (pendingRequestsResponse.success) {
                        this.pendingList = pendingRequestsResponse.data;
                    }
                }
            },

            filterChanged() {
                this.gridApi.setQuickFilter(document.getElementById('search-box').value);
            },

            setColumnsVisibility() {
                this.columnsFilter.forEach(c => {
                    this.gridOptions.columnApi.setColumnVisible(c.id, c.show);
                });
                // TODO this needs optimization
                if (window.innerWidth > 1024)
                    this.gridApi.sizeColumnsToFit();
            }
        },
        computed: {
            getWithdrawals() {
                return this.pendingList;
            },
            paginationPageSize() {
                return 10; // TODO maybe change
            },
            paginationMaxSize() {
                if (this.gridApi) {
                    let pagesNr = this.gridApi.paginationGetTotalPages();
                    return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
                } else
                    return 1;
            },
            totalPages() {
                if (this.gridApi)
                    return this.gridApi.paginationGetTotalPages();
                else
                    return 0;
            },
            currentPage: {
                get() {
                    if (this.gridApi)
                        return this.gridApi.paginationGetCurrentPage() + 1;
                    else
                        return 1;
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.columnsFilter = this.pendingListColumns.filter(c => !c.hideFromFilter).map(c => {
                return {id: c.field, name: c.headerName, show: true};
            });
        },
        data() {
            return {
                balance: 0,
                pendingList: null,
                withdrawalAmount: 100,
                errorText: '',
                gridOptions: {},
                gridApi: null,
                searchInput: '',
                pendingListColumns: [
                    {
                        headerName: '',
                        cellRendererFramework: 'CellRendererButton',
                        hideFromFilter: true
                    },
                    {
                        headerName: 'Value',
                        field: 'value',
                        cellRendererFramework: 'CellRendererValue'
                    },
                    {
                        headerName: 'Name',
                        field: 'user.first_name'
                    },
                    {
                        headerName: 'Last name',
                        field: 'user.last_name'
                    },
                    {
                        headerName: 'Email',
                        field: 'user.email'
                    },
                    {
                        headerName: 'Description',
                        field: 'description',
                        //width: 300
                    },
                    {
                        headerName: 'Created at',
                        field: 'created_at',
                        cellRendererFramework: 'CellRendererDate',
                        // width: 300
                    },
                ],
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnsFilter: [],
                showFilters: false
            }
        }
    }
</script>
